import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { VersionCheckService } from '../../services/version-check.service';

@Component({
  selector: 'app-version-update-notification',
  templateUrl: './version-update-notification.component.html',
  styleUrls: ['./version-update-notification.component.scss']
})
export class VersionUpdateNotificationComponent implements OnInit, OnDestroy {
  public showNotification = false;
  private subscription: Subscription | null = null;

  constructor(private versionCheckService: VersionCheckService) {}

  public ngOnInit(): void {
    this.subscription = this.versionCheckService.updateAvailable$.subscribe(
      (available) => {
        this.showNotification = available;
      }
    );
  }

  public ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  }

  public dismissNotification(): void {
    this.showNotification = false;
  }

  // Getter that can be spied on in tests
  public get refreshPage(): () => void {
    return () => this._refreshPageImpl();
  }

  // Method implementation using a getter for better testability
  private _refreshPageImpl(): void {
    window.location.reload();
  }
}
